// 9fbef606107a605d69c0edbcd8029e5d
import React, { useState, useEffect, useCallback } from 'react';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import Modal from '@tcp/core/src/components/common/molecules/Modal/view/Modal';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Button from '@tcp/core/src/components/common/atoms/Button';
import LabeledRadioButton from '@tcp/core/src/components/common/atoms/LabeledRadioButton';
import { scrollToPlpBreadcrumbs, scrollToTop } from '@tcp/core/src/utils/utils.web';
import PropTypes from 'prop-types';
import style from '../styles/ProductListingFilterPillForm.style';
import { modalStyles } from '../styles/ProductListingFilterPillFormAnimation.style';
import getSortOptions from '../../SortSelector/views/Sort.util';
import FilterPill from '../../../../../../common/molecules/FilterPill/views/FilterPill';
import { FACETS_FIELD_KEY } from '../../../../../../../services/abstractors/productListing/productListing.utils';
import SideBar from '../../../views/SideBar';
import {
  getAccessibilityLabels,
  getBopisLabels,
} from '../../ProductListingFiltersForm/views/ProductListingFiltersForm.labels';

import {
  AddOrRemovePriceFilterPill,
  finalFilterPillsList,
  facetNameChange,
} from './ProductListingFilterPillHelper';
import { isShopThisStoreModeOn } from '../../../../../../../reduxStore/selectors/session.selectors';
import {
  FAVORITES_LABELS,
  FavoriteLabels,
  lblFilter,
  lblSort,
} from '../../../../Favorites/labels/Favorites.labels';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../../../utils/labels/labelUtilty';
import { PLPLabels, PLP_SORT_LABELS } from '../../../../../../../utils/labels/browse/PLP.labels';
import { globalSortingLabels } from '../../../../../../../utils/labels/globalSorting.labels';
import { GlobalGenericLabels } from '../../../../../../../utils/labels/globalGeneric.labels';
import { globalCommonBrowseLabels } from '../../../../../../../utils/labels/globalCommonBrowseLabels.labels';
import { GlobalAccessibilityLabels } from '../../../../../../../utils/labels/globalAccessibility.labels';
import OneHrFilterContainer from '../../../../OneHrFilter/container/OneHrFilter.container';
import { getCurrentFeatureBrandAttribute } from '../../../../SearchDetail/container/SearchDetail.util';

const getSortLength = (FormValuesLocal, initialValues) => {
  if (FormValuesLocal && FormValuesLocal.sort) {
    return FormValuesLocal?.sort;
  }
  return initialValues?.sort;
};

const FILTER_SORT_REDESIGN_CLASS = 'filter-sort-redesign';

const getFilterPillImg = ({
  isAppFilterCountAboveZero,
  isPLPSortAndOneHrFilterRedesignEnabled,
}) => {
  if (isPLPSortAndOneHrFilterRedesignEnabled) return 'filter-black';
  return isAppFilterCountAboveZero ? 'filter' : 'blackFilter';
};

const getSortPillImg = ({ sortLengthAboveZero, isPLPSortAndOneHrFilterRedesignEnabled }) => {
  if (isPLPSortAndOneHrFilterRedesignEnabled) return 'sort';
  return sortLengthAboveZero ? 'whiteSort' : 'sort';
};

// eslint-disable-next-line sonarjs/cognitive-complexity, complexity
function ProductListingFilterPillForm(props) {
  const labelsObj = {
    global: {
      generic: getLabelFromCopyOrFromTranslation('global.generic', GlobalGenericLabels),
      CommonBrowseLabels: getLabelFromCopyOrFromTranslation(
        'global.CommonBrowseLabels',
        globalCommonBrowseLabels
      ),
      Sorting: getLabelFromCopyOrFromTranslation('global.Sorting', globalSortingLabels),
    },
    PLP: getLabelFromCopyOrFromTranslation('PLP', PLPLabels),
  };
  const accessibilityLabelsObj = getLabelFromCopyOrFromTranslation(
    'global.accessibility',
    GlobalAccessibilityLabels
  );
  const accessibilityLabels = getAccessibilityLabels(accessibilityLabelsObj);
  const labelsBopis = getBopisLabels(labelsObj);
  const favLabels = getLabelFromCopyOrFromTranslation(FAVORITES_LABELS, FavoriteLabels);
  const labels = getLabelFromCopyOrFromTranslation(PLP_SORT_LABELS, PLPLabels);
  const sortLabels = getLabelFromCopyOrFromTranslation('global.Sorting', globalSortingLabels);
  const {
    className,
    favoriteSortingParams,
    isFavoriteView,
    handleSubmitOnChangeSort,
    removeAllFilters,
    formValues,
    filtersMaps,
    totalProductsCount,
    initialValues,
    filtersLength,
    onSubmit,
    getProducts,
    isFilterBy,
    isLoadingMore,
    isABTestForStickyFilter,
    isBopisFilterOn,
    updateFormValue,
    defaultStoreData,
    categoryNavData = {},
    categoryPlp,
    isBopisFilterEnabled,
    setBopisFilterStateActn,
    resetSuggestedStores,
    isPaginationViewEnabled,
    selectedPageProductCount,
    productLimitPerPage,
    selectedPage,
    trackClickAnalyticsBopisFilter,
    newFilterTrackAnalytics,
    isSizeGroupFilterEnabled,
    sortByRatingLabel,
    isCustomerRatingFilterWebEnabled,
    isTileRedesignAB,
    isHPLP,
    pathName,
    isSLP,
    isFeatureBrandView,
    isFeatureBrandEnabled,
    setPriceFilterFlagActn,
    isPLPSortAndOneHrFilterRedesignEnabled,
  } = props;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isFilterForm, setIsFilterForm] = useState(false);
  const [selectedSortOption, setSelectedSortOption] = useState('');
  const [selectedFilterOption, setSelectedFilterOption] = useState('');
  const [tabPriceRange, setTabPriceRange] = useState(false);
  const [FormValuesLocal, setFormvaluesLocal] = useState(formValues);
  const sortOptions = favoriteSortingParams || getSortOptions({ sortByRatingLabel });
  const filterUnbxdNameMaplist = { ...filtersMaps?.unbxdDisplayName };
  const updatedFacetNames = facetNameChange(filterUnbxdNameMaplist);
  const updatedFilterNamesListGreaterThanOne = AddOrRemovePriceFilterPill(filtersMaps);
  const listOfPills = finalFilterPillsList(
    updatedFilterNamesListGreaterThanOne,
    updatedFacetNames,
    FormValuesLocal,
    isSizeGroupFilterEnabled,
    initialValues,
    isFeatureBrandView
  );
  const sortLengthAboveZero = getSortLength(FormValuesLocal, initialValues);

  const onCloseClick = () => {
    setTimeout(() => {
      if (selectedSortOption?.length === 0 || Object.keys(formValues).length === 0) {
        setFormvaluesLocal({ ...FormValuesLocal });
      } else {
        setFormvaluesLocal({ ...formValues });
      }
      setIsModalOpen(false);
    }, 0);
  };

  const handleSortPillForm = () => {
    setTimeout(() => {
      setSelectedSortOption(FormValuesLocal.sort || '');
      setIsModalOpen(true);
      setIsFilterForm(false);
    }, 0);
  };
  const handleFilterPillForm = (e) => {
    setTimeout(() => {
      setSelectedFilterOption(e?.target?.innerText?.trim());
      setIsModalOpen(true);
      setIsFilterForm(true);
    }, 0);
  };

  const handleSortOptionChange = (sortValue) => {
    setTimeout(() => {
      setSelectedSortOption(sortValue);
      const sortFormValues = {
        sort: sortValue,
      };
      scrollToTop();
      handleSubmitOnChangeSort({ ...FormValuesLocal, ...sortFormValues });
    }, 0);
  };

  const ResetAllfilters = () => {
    setTimeout(() => {
      removeAllFilters();
      if (isHPLP) {
        scrollToPlpBreadcrumbs();
      } else {
        scrollToTop();
      }
      setFormvaluesLocal({ sort: '' });
      setTabPriceRange(true);
    }, 0);
  };

  const getAppliedFiltersCount = useCallback(() => {
    let count = 0;
    if (initialValues) {
      const filteredData = Object.fromEntries(
        Object.entries(initialValues).filter(([key]) => key !== 'filter_cat_grp')
      );
      Object.keys(filteredData)
        ?.filter((filter) => {
          if (!isFeatureBrandView) return true;
          return (
            filter?.toLowerCase() !== getCurrentFeatureBrandAttribute(filtersMaps).toLowerCase()
          );
        })
        .forEach((filter) => {
          count +=
            filter?.toLowerCase() !== FACETS_FIELD_KEY.sort ? filteredData[filter].length : 0;
        });
    }
    return !isShopThisStoreModeOn() ? count : count - 1;
  }, [initialValues]);

  const appliedFiltersCount = getAppliedFiltersCount(initialValues);
  const isAppFilterCountAboveZero = appliedFiltersCount > 0;

  let filterLabel = isAppFilterCountAboveZero
    ? `${renderLabel(
        !isFavoriteView ? labels[lblFilter] : favLabels[lblFilter],
        lblFilter
      )} (${appliedFiltersCount})`
    : renderLabel(!isFavoriteView ? labels[lblFilter] : favLabels[lblFilter], lblFilter);

  if (isHPLP && renderLabel(labels[lblFilter], lblFilter)) {
    filterLabel = `${renderLabel(labels[lblFilter], lblFilter)} (${appliedFiltersCount})`;
  }

  useEffect(() => {
    if (Object.keys(formValues).length > 0) {
      setFormvaluesLocal({ ...formValues });
    }
  }, [formValues]);
  return (
    <div
      className={`${className} filter-pill-form-container ${
        isPLPSortAndOneHrFilterRedesignEnabled ? 'filter-pill-form-container-redesign' : ''
      }`}
    >
      <div className="scrollPill">
        <FilterPill
          labels={filterLabel}
          pillImg={getFilterPillImg({
            isAppFilterCountAboveZero,
            isPLPSortAndOneHrFilterRedesignEnabled,
          })}
          handleClick={handleFilterPillForm}
          className={`upperText ${isAppFilterCountAboveZero && 'filterTextPill'} ${
            isPLPSortAndOneHrFilterRedesignEnabled ? FILTER_SORT_REDESIGN_CLASS : ''
          }`}
        />
        <FilterPill
          labels={renderLabel(favLabels[lblSort], lblSort)}
          pillImg={getSortPillImg({ sortLengthAboveZero, isPLPSortAndOneHrFilterRedesignEnabled })}
          handleClick={handleSortPillForm}
          className={`upperText ${sortLengthAboveZero && `activeTextPill`} ${
            isPLPSortAndOneHrFilterRedesignEnabled ? FILTER_SORT_REDESIGN_CLASS : ''
          }`}
        />

        {listOfPills?.map((filterName) => (
          <FilterPill
            labels={filterName[0]}
            handleClick={handleFilterPillForm}
            className={`${filterName[1] && isAppFilterCountAboveZero ? `activeTextPill` : ''} ${
              isPLPSortAndOneHrFilterRedesignEnabled ? FILTER_SORT_REDESIGN_CLASS : ''
            }`}
          />
        ))}

        {(isAppFilterCountAboveZero || sortLengthAboveZero) && (
          <FilterPill
            labels={renderLabel(labels.lbl_reset, 'lbl_reset')}
            pillImg="search-close-icon"
            handleClick={ResetAllfilters}
            className={`${
              isPLPSortAndOneHrFilterRedesignEnabled ? FILTER_SORT_REDESIGN_CLASS : ''
            }`}
          />
        )}
      </div>
      <div>
        {!isShopThisStoreModeOn() && !isPLPSortAndOneHrFilterRedesignEnabled && (
          <OneHrFilterContainer
            pathName={pathName}
            isSLP={isSLP}
            getProducts={getProducts}
            isFeatureBrandView={isFeatureBrandView}
            isFeatureBrandEnabled={isFeatureBrandEnabled}
          />
        )}
      </div>
      {isModalOpen && (
        <Modal
          fixedWidth
          isOpen={isModalOpen}
          onRequestClose={onCloseClick}
          className={`TCPModal__Content, ${className}`}
          innerContentClassName={`filter-innerContent ${!isFilterForm ? '' : 'filterFormHeight'}`}
          inheritedStyles={modalStyles}
          heading={
            isFilterForm
              ? renderLabel(labels.lbl_filter, 'lbl_filter')
              : renderLabel(labels.lbl_sort, 'lbl_sort')
          }
          headingAlign="center"
          overlayClassName="TCPModal__Overlay"
          headingFontWeight="bold"
          headingFontFamily="secondary"
          isHPLP
        >
          {!isFilterForm ? (
            <form className="sort-options-container">
              {sortOptions.map((sortOption) => {
                return (
                  <div className={`sortOptionId ${sortOption.displayName}`} key={sortOption.id}>
                    <LabeledRadioButton
                      className={`${className} ${
                        selectedSortOption === sortOption.id ? 'sort-selected' : 'sort-option-title'
                      }`}
                      inputName={sortOption.displayName}
                      title={sortOption.displayName}
                      selectedValue={sortOption.id}
                      checked={selectedSortOption === sortOption.id}
                      isFavoriteView={isFavoriteView}
                      onChange={() => handleSortOptionChange(sortOption.id)}
                    />
                  </div>
                );
              })}
              <SideBar selectedSortOption={selectedSortOption} />
            </form>
          ) : (
            <div
              className={`custom-filter-form ${
                !isFilterForm ? 'sort-form-cnt' : 'filter-form-cnt'
              }`}
            >
              <SideBar
                filtersMaps={filtersMaps}
                totalProductsCount={totalProductsCount}
                initialValues={initialValues}
                filtersLength={filtersLength}
                onSubmit={onSubmit}
                formValues={formValues}
                getProducts={getProducts}
                sortLabels={sortLabels}
                isFilterBy={isFilterBy}
                isLoadingMore={isLoadingMore}
                isABTestForStickyFilter={isABTestForStickyFilter}
                isBopisFilterOn={isBopisFilterOn}
                labelsBopis={labelsBopis}
                updateFormValue={updateFormValue}
                defaultStoreData={defaultStoreData}
                categoryNavData={categoryNavData}
                selectedFilterOption={selectedFilterOption}
                categoryPlp={categoryPlp}
                isBopisFilterEnabled={isBopisFilterEnabled}
                setBopisFilterStateActn={setBopisFilterStateActn}
                resetSuggestedStores={resetSuggestedStores}
                isPaginationViewEnabled={isPaginationViewEnabled}
                selectedPageProductCount={selectedPageProductCount}
                productLimitPerPage={productLimitPerPage}
                selectedPage={selectedPage}
                setTabPriceRange={setTabPriceRange}
                tabPriceRange={tabPriceRange}
                trackClickAnalyticsBopisFilter={trackClickAnalyticsBopisFilter}
                newFilterTrackAnalytics={newFilterTrackAnalytics}
                isSizeGroupFilterEnabled={isSizeGroupFilterEnabled}
                isCustomerRatingFilterWebEnabled={isCustomerRatingFilterWebEnabled}
                isTileRedesignAB={isTileRedesignAB}
                accessibilityLabels={accessibilityLabels}
                isHPLP={isHPLP}
                isFeatureBrandView={isFeatureBrandView}
                setPriceFilterFlagActn={setPriceFilterFlagActn}
              />
            </div>
          )}

          <div className={`see-results-container ${!isFilterForm ? 'sort-cnt' : 'filter-cnt'}`}>
            {isFilterForm && (
              <Button onClick={ResetAllfilters} className="clear-button" isHPLP>
                <BodyCopy
                  fontFamily="secondary"
                  fontSize="fs14"
                  fontWeight="extrabold"
                  color="white.500"
                  textAlign="center"
                >
                  {renderLabel(labels.lbl_clearTxt, 'lbl_clearTxt')}
                </BodyCopy>
              </Button>
            )}
            <Button onClick={onCloseClick} className="see-results-button" isHPLP>
              <BodyCopy
                fontFamily="secondary"
                fontSize="fs14"
                fontWeight="extrabold"
                color="white.500"
                textAlign="center"
              >
                {`${renderLabel(labels.lbl_see_results, 'lbl_see_results')} ${
                  isFilterForm && !isHPLP ? `(${totalProductsCount})` : ''
                }`}
              </BodyCopy>
            </Button>
          </div>
        </Modal>
      )}
    </div>
  );
}

ProductListingFilterPillForm.propTypes = {
  className: PropTypes.string,
  favoriteSortingParams: PropTypes.shape({}),
  isFavoriteView: PropTypes.bool,
  handleSubmitOnChangeSort: PropTypes.func,
  removeAllFilters: PropTypes.func,
  formValues: PropTypes.shape({ sort: PropTypes.string }),
  filtersMaps: PropTypes.shape({ unbxdDisplayName: PropTypes.shape({}) }),
  totalProductsCount: PropTypes.string,
  initialValues: PropTypes.shape({}),
  filtersLength: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.number])),
  onSubmit: PropTypes.func.isRequired,
  getProducts: PropTypes.func.isRequired,
  isFilterBy: PropTypes.bool,
  isLoadingMore: PropTypes.bool,
  isABTestForStickyFilter: PropTypes.bool,
  isBopisFilterOn: PropTypes.bool,
  defaultStoreData: PropTypes.shape({}),
  categoryNavData: PropTypes.shape({}),
  updateFormValue: PropTypes.func,
  categoryPlp: PropTypes.bool,
  isSizeGroupFilterEnabled: PropTypes.bool,
};

ProductListingFilterPillForm.defaultProps = {
  className: '',
  favoriteSortingParams: null,
  filtersMaps: {},
  isFavoriteView: false,
  formValues: { sort: '' },
  handleSubmitOnChangeSort: () => {},
  removeAllFilters: () => {},
  initialValues: {},
  filtersLength: {},
  isFilterBy: true,
  isLoadingMore: false,
  isABTestForStickyFilter: false,
  isBopisFilterOn: false,
  totalProductsCount: '0',
  defaultStoreData: {},
  categoryNavData: {},
  updateFormValue: () => {},
  categoryPlp: true,
  isSizeGroupFilterEnabled: false,
};

export default withStyles(ProductListingFilterPillForm, style);
export { ProductListingFilterPillForm as ProductListingFilterPillFormVanilla };
